import { PieChartOutlined } from "@ant-design/icons";
import { pieCore } from "./core/pie";
import { defineWidget } from "../widgetDefinition";
import { pieSlots } from "../Slots";
import { pieDuplicate } from "../Duplication/pie";
import { pieControlPanel } from "../ControlPanel/pie";
import type { PieChartComponentSpec } from "../Processing/types";
import { PieWidget } from "../WidgetComponents/PieWidget";
import { PieInfo } from "../Info/pie";
import { PieConfigurator } from "../AddWidgetModal/PieConfigurator";
import { BINDABLE_SECTIONS } from "../Processing/controllerBindings";

export const pieDefinition = defineWidget<PieChartComponentSpec>({
  ...pieCore,
  type: "pie_chart",
  dynamic: { bindableSections: BINDABLE_SECTIONS.pie_chart },
  slots: pieSlots,
  duplicate: pieDuplicate,
  controlPanel: pieControlPanel,
  info: { Content: PieInfo },
  schema: ["display", "widgetMutations", "series", "pie_builder_misc"],
  contractHash: "1wm95xly76b",
  needsData: true,

  template: {
    label: "Pie Chart",
    description: "Show how a metric is distributed across players or groups",
    icon: <PieChartOutlined />,
  },

  defaultLayout: { w: 5, h: 10, minW: 3, minH: 4 },

  gridComponent: ({ id }) => <PieWidget id={id} />,

  configurator: {
    modalTitle: "Pie Chart Widget",
    wide: true,
    Component: PieConfigurator as any,
  },
});
